import React 				from 'react';
import ReactDOM 			from 'react-dom';
import BLComponent			from '../../core/_BLComponent.jsx';

export default class AddItemModalBody extends BLComponent 
{
	
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 
		
	}

	render()
	{
		const itemTypeList = {P:"Part", B:"Book", M:"Minifigure", C:"Catalog", S:"Set", G:"Gear"};
		const {itemType, addRes, isPartOutResModal} = this.props.data;
		const itemTypeName = (isPartOutResModal)?"Part":itemTypeList[itemType];
		const itemTypeNameFrom = itemTypeList[itemType].toLowerCase();
		
		let pluralAdd = false;
		let pluralUpd = false;

		if (itemType != "G") {
			if (addRes.itemAdded > 1) pluralAdd = true;
			if (addRes.itemUpdated > 1) pluralUpd = true;
		}
		
		return (
			<section className="personal-inventory__add-set-modal-body">
				<div className="text--center text--bold l-margin-bottom--xl">
					My {itemTypeName}{((itemTypeName != "Gear")?"s":"")} has been updated
				</div>
				<div className="text--center personal-inventory__modal-icon-xl--green l-margin-bottom">
					<i className="fa-solid fa-circle-check"></i>
				</div>
				<div>
					Success! You’ve made the following changes to My {itemTypeName + ((itemType != "G")?"s":"")}:
				</div>
				<ul className="personal-inventory__list-disc l-margin-bottom--xl l-margin-top--xl">
					{(addRes.itemAdded > 0)&&
						<li className="text--bold">{addRes.itemAdded} {itemTypeName}{  (pluralAdd)?"s":""} added</li>
					}
					{(addRes.itemUpdated > 0)&&
						<li className="text--bold">{addRes.itemUpdated} {itemTypeName}{(pluralUpd)?"s":""} updated</li>
					}
					{(addRes.itemPartedOut > 0)&&
						<li className="text--bold">{addRes.itemPartedOut} {itemTypeNameFrom} inventories added to My Parts</li>
					}
				</ul>
			</section>
		);
	}

	


};

 

